module.exports = __webpack_public_path__ + "static/media/notes_icon.9ccb30eb.svg";